import { CheckCircle2, Clock } from 'lucide-react';
import { formatAgo, formatDateTime } from '../lib/format';

/**
 * Has the instance picked up the last change? It reads its settings at every
 * heartbeat, so a heartbeat newer than the save means yes. `savedAt` is the
 * tenant's last update; the page refreshes itself, so this flips on its own.
 */
export function AppliedHint({
  savedAt,
  lastSeenAt,
}: {
  savedAt: string;
  lastSeenAt: string | null;
}) {
  const applied = lastSeenAt !== null && new Date(lastSeenAt) > new Date(savedAt);
  if (applied) {
    return (
      <p className="flex items-center gap-1.5 text-xs text-emerald-300">
        <CheckCircle2 className="h-3.5 w-3.5" />
        Aplicat de instanță · ultimul heartbeat {formatAgo(lastSeenAt)} (
        {formatDateTime(lastSeenAt!)})
      </p>
    );
  }
  return (
    <p className="flex items-center gap-1.5 text-xs text-amber-300">
      <Clock className="h-3.5 w-3.5" />
      Salvat {formatAgo(savedAt)}; instanța aplică la următorul heartbeat (de obicei sub 5 minute).
      Ultimul semn de viață: {formatAgo(lastSeenAt)}.
    </p>
  );
}
